<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="800" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 Create new room
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.px-6.py-3
      v-form(ref="form")
        v-row.mt-0
          v-col
            div.text-sm.font-semibold.neutral500--text Room name
            v-text-field.text-sm.mt-2.round-xl(v-model="name" placeholder="Enter name" outlined dense height="48" hide-details="auto" :rules="rules.not_empty")
          v-col
            div.text-sm.font-semibold.neutral500--text Description (Optional)
            v-text-field.text-sm.mt-2.round-xl(v-model="description" placeholder="Enter description" outlined dense height="48" hide-details="auto")

    v-card-actions.pb-4.pt-3.px-6
      y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button(label="Save" text-color="neutral100" color="neutral700" size="md" dark :loading="isLoading" @click="saveData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PhoneInput from '@/components/clinic/custom/PhoneInput.vue'

export default {
  components: { PhoneInput },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    stock: {
      default: null
    },
    product: {
      default: null
    }
  },
  data() {
    return {
      isFetching: false,
      isLoading: false,
      name: null,
      description: null,
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required'],
      },
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {},
  methods: {
    ...mapActions(['showMessage']),
    saveData () {
      this.isLoading = true
      let data = {
        name: this.name,
        type: 'room',
        description: this.description,
        schedule_enabled: false,
        services: []
      }
      this.$axios.post(`/clinics/${this.company.slug}/facilities`, data)
        .then(() => {
          this.closeDialog()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeDialog () {
      this.$emit('closed')
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .date-field .v-input__append-inner {
    margin-top: 12px !important;
  }
}
</style>